import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { ButtBox } from '@tecuity/granite-ui/ButtBox'
import { BoxSelect } from '@tecuity/granite-ui/BoxSelect'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { ContextDataChip } from '@tecuity/granite-ui/ContextDataChip'
import { FilterablePopover } from '@tecuity/granite-ui/FilterablePopover'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { UserChip } from '@tecuity/granite-ui/UserChip'
import { Body, Drawer } from '../Shell/Shell'
import BulkAssignment from '../WorkviewManager/BulkAssignment'
import CorrectionResolver from '../WorkviewManager/CorrectionResolver'
import { Spinner } from '../Loaders/Loaders'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import OrdersPaperProcessModal from './OrdersPaperProcessModal/OrdersPaperProcessModal'
import PaperProccessModal from '../WorkviewManager/PaperProcessModel/PaperProcessModal'
import WebProcessModal from '../WorkviewManager/WebProcessModal'
import { setErrorToast, setSuccessToast } from '../../actions'
import { checkDLNValid } from '../BOSearch/BOSearchActions'
import { openSpecificImage } from '../ImageViewer/ImageViewerActions'
import Cross from '@tecuity/sos-icons/react/cross-heavy'
import Document from '@tecuity/sos-icons/react/document'
import FileBox from '@tecuity/sos-icons/react/file-box'
import FileBoxSolid from '@tecuity/sos-icons/react/file-box-solid'
import Revert from '@tecuity/sos-icons/react/revert'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import {
  SET_MY_ASSIGNED_CHECKED,
  SET_UNASSIGNED_CHECKED,
  SET_WORKVIEW_2_ACTIVE_CATEGORY_ID,
  SET_WORKVIEW_2_CATEGORY_USERS,
  SET_WORKFLOW_OPTIONS,
  SET_SELECTED_ROW,
  SET_RECORD_TO_AMEND,
  SET_LIEN_FORMS,
  SET_TRADEMARK_FORMS,
  SET_ORDER_FORMS,
  SET_BUSINESS_FORMS,
  SET_NOTARY_FORMS,
  SET_REGISTERED_AGENT_FORMS,
  SET_ATHLETE_AGENT_FORMS,
  SET_PAPER_FILING_ERROR_MESSAGE,
} from './Workview2Reducer'
import { SET_CORRESPONDENCE_WORKVIEW_ITEM } from '../WVMCorrespondence/Correspondence2Reducer'
import { SET_RECEIPT_WORKVIEW_ITEM } from '../Accounting/ReceiptValidation/ReceiptValidationReducer'
import * as api from '../../requests'
import '../WorkviewManager/WorkviewManager.scss'
import { useHistory } from 'react-router'
import LockKey from '@tecuity/sos-icons/react/lock-key'
import { useDebounce, useRequestData } from '../../Utilities/hooks'
import LegacyFilingsModal from './LegacyFilingsModal/LegacyFilingsModal'
import MiscPaperProcessModal from './MiscPaperProcessModal/MiscPaperProcessModal'
import { FilingSourceTypeIds, ProcessingStatusIds } from '../../Utilities/Utilities'
import WorkViewItemNotes from './WorkViewItemNotes/WorkViewItemNotes'

//FUTURE ENHANCEMENT: Handle server side events to keep result list updated
//https://www.npmjs.com/package/@microsoft/fetch-event-source

const WorkviewManager = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [searchText, setSearchText] = useState('')
  const debouncedSearchText = useDebounce(searchText, 250)
  const [bulkAssign, setBulkAssign] = useState(false)
  const [correctionResolverOpen, setCorrectionResolverOpen] = useState(false)
  const [bulkSelectedItems, setBulkSelectedItems] = useState([])
  const [bulkSelectedPeople, setBulkSelectedPeople] = useState([])
  const [assignUserPopoverOpen, setAssignUserPopoverOpen] = useState(false)
  const [popoverLocation, setPopoverLocation] = useState({ top: 0, left: 0 })
  const [showValidatingActionSpinner, setShowValidatingActionSpinner] = useState(false)
  const [processFlag, setProcessFlag] = useState(false)
  const [loading, setLoading] = useState(false)
  const [resultRows, setResultRows] = useState([newDTO])
  const [filteredRowCount, setFilteredRowCount] = useState(0)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(25)
  const [sortInfo, setSortInfo] = useState({})
  const [legacyFilingModalOpen, setLegacyFilingModalOpen] = useState(false)
  const [orderPaperModalOpen, setOrderPaperModalOpen] = useState(false)
  const [paperModalOpen, setPaperModalOpen] = useState(false)
  const [miscPaperModalOpen, setMiscPaperModalOpen] = useState(false)
  const [webModalOpen, setWebModalOpen] = useState(false)
  const [activeWorkView, setActiveWorkView] = useState({})
  const [workViewList, setWorkViewList] = useState([])
  const [notesOpen, setNotesOpen] = useState(false)
  const {
    roles,
    appUserRights,
    FIRST_NAME: userFirstName,
    LAST_NAME: userLastName,
    WEB_USER_ID: userId,
  } = useSelector((state) => state.auth, shallowEqual)
  const {
    workviewCategoryUsers,
    activeCategoryId,
    myAssignedChecked,
    unassignedChecked,
    workflowOptions,
    selectedRow,
  } = useSelector((state) => state.workview2, shallowEqual)
  const { sidebarCollapsed, activeSourceTypes } = useSelector((state) => state.app, shallowEqual)
  const itemController = useRef()
  const showWvmLockedColors = useRequestData(
    (cb, errCb) => {
      api.GET_APP_SETTING_BY_NAME(
        'ShowWvmLockedColors',
        (setting) => {
          cb(setting.VALUE === 'true')
        },
        errCb
      )
    },
    [],
    false
  )

  useEffect(() => {
    if (itemController.current) {
      itemController.current.abort()
    }
    itemController.current = new AbortController()
    getItems(itemController.current)
    return () => {
      if (itemController.current) itemController.current.abort()
    }
  }, [
    page,
    pageSize,
    myAssignedChecked,
    unassignedChecked,
    debouncedSearchText,
    activeCategoryId,
    sortInfo,
  ])

  useEffect(() => {
    api.GET_WORKVIEW_USERS_LIST(
      (data) => {
        dispatch({ type: SET_WORKVIEW_2_CATEGORY_USERS, workviewCategoryUsers: data })
      },
      (err) => console.error(err)
    )
    fetchAndSetCategoryDropdownOptions(true)
    // NEW CATEGORY ENDPOINT CALL
    if (activeSourceTypes.find((type) => type.ModuleName === 'UCC' && type.IsActive)) {
      api.GET_FORMS(
        'UCC',
        (data) => {
          dispatch({ type: SET_LIEN_FORMS, options: data })
        },
        (err) => {
          dispatch({ type: SET_LIEN_FORMS, options: [] })
          console.error(err)
        }
      )
    }
    if (activeSourceTypes.find((type) => type.ModuleName === 'Trademark' && type.IsActive)) {
      api.GET_FORMS(
        'trademark',
        (data) => {
          // console.log('tm', data)
          dispatch({ type: SET_TRADEMARK_FORMS, options: data })
        },
        (err) => {
          dispatch({ type: SET_TRADEMARK_FORMS, options: [] })
          console.error(err)
        }
      )
    }
    if (activeSourceTypes.find((type) => type.ModuleName === 'Business' && type.IsActive)) {
      api.GET_FORMS(
        'business',
        (data) => {
          dispatch({ type: SET_BUSINESS_FORMS, options: data })
        },
        (err) => {
          dispatch({ type: SET_BUSINESS_FORMS, options: [] })
          console.error(err)
        }
      )
    }
    if (activeSourceTypes.find((type) => type.ModuleName === 'Notary' && type.IsActive)) {
      api.GET_FORMS(
        'notary',
        (data) => {
          dispatch({ type: SET_NOTARY_FORMS, options: data })
        },
        (err) => {
          dispatch({ type: SET_NOTARY_FORMS, options: [] })
          console.error(err)
        }
      )
    }
    if (activeSourceTypes.find((type) => type.ModuleName === 'RegisteredAgent' && type.IsActive)) {
      api.GET_FORMS(
        'registeredAgent',
        (data) => {
          dispatch({ type: SET_REGISTERED_AGENT_FORMS, options: data })
        },
        (err) => {
          dispatch({ type: SET_REGISTERED_AGENT_FORMS, options: [] })
          console.error(err)
        }
      )
    }
    if (activeSourceTypes.find((type) => type.ModuleName === 'AthleteAgent' && type.IsActive)) {
      api.GET_FORMS(
        'athleteAgent',
        (data) => {
          dispatch({ type: SET_ATHLETE_AGENT_FORMS, options: data })
        },
        (err) => {
          dispatch({ type: SET_ATHLETE_AGENT_FORMS, options: [] })
          console.error(err)
        }
      )
    }
    if (
      activeSourceTypes.find(
        (type) => type.ModuleName === 'Orders' || (type.ModuleName === 'Order' && type.IsActive)
      )
    ) {
      api.GET_FORMS(
        'order',
        (data) => {
          dispatch({ type: SET_ORDER_FORMS, options: data })
        },
        (err) => {
          dispatch({ type: SET_ORDER_FORMS, options: [] })
          console.error(err)
        }
      )
    }
    api.GET_WORKVIEW_OPTIONS(
      (res) => {
        setWorkViewList(res)
      },
      (err) => {
        console.error(err)
      }
    )
  }, [activeSourceTypes])

  useEffect(() => {
    activeCategoryId &&
      workViewList &&
      setActiveWorkView(workViewList.find((wv) => wv.Id === activeCategoryId))
  }, [workViewList, activeCategoryId])

  useEffect(() => {
    if (processFlag && selectedRow) {
      setProcessFlag(false)

      if (
        selectedRow.SourceTypeId === FilingSourceTypeIds.Trademark &&
        selectedRow.ProcessingStatusId === ProcessingStatusIds.PendingImageCrop
      ) {
        // Already marked Pending Image Crop: the crop decision was already made, so re-opening the
        // item goes straight back to the crop tool instead of the wizard/process modal.
        history.push('/office/imageCropTool')
      } else if (selectedRow.ProcessingStatusId === ProcessingStatusIds.PendingPaymentDocuments) {
        api.GET_RECEIPT_NUM_BY_IMAGE_GROUP_ID(
          selectedRow.ImageGroupId,
          (num) => {
            dispatch({ type: SET_RECEIPT_WORKVIEW_ITEM, workviewItem: selectedRow })
            dispatch(
              setSuccessToast(
                'The wizard for this document has already been completed. Please review and save the receipt to complete the approval process.'
              )
            )
            appUserRights.includes(`ReceiptView`) && history.push(`/accounting/receipt/${num}`)
          },
          (error) => {
            dispatch(setErrorToast(error))
          }
        )
      } else if (selectedRow.ProcessingStatusId === ProcessingStatusIds.PendingSecondaryReview) {
        api.GET_FILING_LAST_MODIFIED_BY_USER_ID(
          selectedRow.SourceTypeId,
          selectedRow.Filing.Num,
          (lastModifiedByUserId) => {
            if (
              lastModifiedByUserId === userId &&
              !appUserRights.includes('BypassSecondaryValidation')
            ) {
              dispatch(
                setErrorToast(`A different user must complete the secondary review of this Filing.`)
              )
              api.UNLOCK_WORKVIEW_ITEM_BY_ID(
                selectedRow.WorkViewItemId,
                () => {
                  changeUser(-1, selectedRow.WorkViewItemId)
                },
                (err) => {
                  console.error(err)
                }
              )
            } else if (lastModifiedByUserId > 1) {
              dispatch({
                type: SET_SELECTED_ROW,
                selectedRow: { ...selectedRow, previousReviewerUserId: lastModifiedByUserId },
              })
              history.push(
                `/office/workview/process/${selectedRow.FormDefinitionId}${
                  selectedRow.Filing.Num ? `/${selectedRow.Filing.Num}` : ''
                }`
              )
            } else {
              console.error('System User CANNOT be an Initial Filer. See Admin.')
            }
          },
          (err) => {
            console.error(err)
            dispatch(setErrorToast(`Filing: ${selectedRow.Filing.Num} not found.`))
          }
        )
      } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Receipt) {
        dispatch({ type: SET_RECEIPT_WORKVIEW_ITEM, workviewItem: selectedRow })
        appUserRights.includes(`ReceiptView`) && history.push('/accounting/receipt')
      } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy) {
        setLegacyFilingModalOpen(true)
      } else if (
        selectedRow.SourceTypeId === FilingSourceTypeIds.InfoRequest &&
        (selectedRow.EntryTypeName === 'Paper Filed' || selectedRow.EntryTypeName === '')
      ) {
        if (!selectedRow.FormDefinitionId) {
          api.GET_APP_SETTING_BY_NAME('LienInformationRequestFormId', (data) => {
            getStaffDraftAndRedirect(parseFloat(data.VALUE))
          })
        }
      } else if (selectedRow.StaffEntryRequiredFlag === true) {
        if (selectedRow.SourceTypeId === FilingSourceTypeIds.ServiceOfProcess) {
          if (selectedRow.FormDefinitionId !== 0) {
            getStaffDraftAndRedirect(parseFloat(selectedRow.FormDefinitionId))
          }
        } else if (selectedRow.FormDefinitionId !== 0) {
          getStaffDraftAndRedirect(parseFloat(selectedRow.FormDefinitionId), true)
        } else {
          OpenModals()
        }
      } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Apostille) {
        api.GET_APP_SETTING_BY_NAME('APOSTILLE_FORM_DEFINITION_ID', (data) => {
          getStaffDraftAndRedirect(parseFloat(data.VALUE))
        })
      } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Facsimile) {
        api.GET_APP_SETTING_BY_NAME('FACSIMILE_FORM_DEFINITION_ID', (data) => {
          getStaffDraftAndRedirect(parseFloat(data.VALUE))
        })
      } else {
        OpenModals()
      }
    }
  }, [processFlag, selectedRow])

  /* END useEffect */
  /* START functions */
  const closeBulkAssignmentDrawer = () => {
    setBulkAssign(false)
    setBulkSelectedItems([])
    setBulkSelectedPeople([])
  }

  const OpenModals = () => {
    if (selectedRow.EntryTypeName.includes('Web')) {
      setWebModalOpen(true)
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders) {
      setOrderPaperModalOpen(true)
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Miscellaneous) {
      setMiscPaperModalOpen(true)
    } else {
      selectedRow.SourceTypeId === 0 ? setCorrectionResolverOpen(true) : setPaperModalOpen(true)
    }
  }

  const changeBulkUsers = (list) => {
    setLoading(true)
    api.BULK_ASSIGN_WORKVIEW_ITEMS(
      list,
      (data) => {
        refreshView()
        dispatch(setSuccessToast('Successfully assigned work items.'))
        setBulkSelectedItems([])
        setBulkSelectedPeople([])
        setLoading(false)
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to assign work items.'))
        setLoading(false)
      }
    )
  }

  const fetchAndSetCategoryDropdownOptions = (initialize = false) => {
    api.GET_WORKVIEW_DROPDOWN_OPTIONS(
      (data) => {
        dispatch({ type: SET_WORKFLOW_OPTIONS, workflowOptions: data })
        if (initialize) {
          let workviewId = activeCategoryId || null
          if (!workviewId) {
            const allWorkview = data.find(
              (opt) => (opt.Name || '').toUpperCase() === 'All'.toUpperCase()
            )
            if (allWorkview) workviewId = allWorkview.WorkviewId
          }
          if (!workviewId) workviewId = data[0].WorkviewId
          dispatch({ type: SET_WORKVIEW_2_ACTIVE_CATEGORY_ID, activeCategoryId: workviewId })
        }
      },
      (err) => {
        console.error(err)
      }
    )
  }

  const openAssignUserPopover = (e) => {
    if (!document.getElementsByClassName('popoverJSSelector')[0]) {
      return
    }
    const button = e.target.nodeType === 'button' ? e.target : e.target.closest('button')
    const bodyRect = document.body.getBoundingClientRect()
    const elemRect = button.getBoundingClientRect()
    const buttonLocationY = elemRect.top - bodyRect.top
    const buttonLocationX = elemRect.left - bodyRect.left
    const buttonHeight = button.offsetHeight
    const popoverHeight = 352 // will be 352 after setAssignUserPopoverOpen is called

    let calculatedPopoverY = buttonLocationY + buttonHeight - window.scrollY
    let calculatedPopoverX = buttonLocationX

    // if the popover would overflow the bottom of the screen, move it up
    if (calculatedPopoverY + popoverHeight > window.innerHeight) {
      calculatedPopoverY = calculatedPopoverY - popoverHeight - buttonHeight
      // console.log('after calculating: ', calculatedPopoverY)
    } else {
      // console.log('not overflowing bottom')
    }

    setPopoverLocation({ top: calculatedPopoverY, left: calculatedPopoverX })
    setAssignUserPopoverOpen(true)
  }

  const getItems = (controller) => {
    setLoading(true)
    setResultRows([])
    // CALL TO GET PAGINATED LIST
    if (activeCategoryId) {
      api.GET_WORKVIEW_ITEMS(
        activeCategoryId,
        page,
        pageSize,
        myAssignedChecked,
        unassignedChecked,
        debouncedSearchText,
        sortInfo.orderBy, //orderBy,
        sortInfo.orderByDesc, //orderByDesc,
        { signal: controller.signal },
        (data) => {
          itemController.current = null
          setResultRows(data)
          setLoading(false)
        },
        (err) => {
          console.error(err)
          setLoading(false)
        }
      )
      if (myAssignedChecked || unassignedChecked || debouncedSearchText)
        api.GET_WORKVIEW_ITEMS_COUNT(
          activeCategoryId,
          page,
          pageSize,
          myAssignedChecked,
          unassignedChecked,
          debouncedSearchText,
          { signal: controller.signal },
          (count) => {
            setFilteredRowCount(count)
          },
          (err) => {
            console.error(err)
            setFilteredRowCount(0)
          }
        )
      else setFilteredRowCount(0)
    }
    fetchAndSetCategoryDropdownOptions()
  }

  const changeUser = (userId, workviewItemId) => {
    setAssignUserPopoverOpen(false)
    api.SET_ASSIGNED_WORKVIEW_USER_BY_ID(
      [{ userId, workviewItemId }],
      () => {
        refreshView()
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Assign User'))
      }
    )
  }

  const changeView = (selectedCategory) => {
    // console.log(selectedCategory)
    const categoryId = selectedCategory.value
    const allCategory = (categoryDropdownOptions || []).find(
      (opt) => (opt.label || '').toUpperCase() === 'All'.toUpperCase()
    )
    setPage(0)
    dispatch({ type: SET_WORKVIEW_2_ACTIVE_CATEGORY_ID, activeCategoryId: categoryId })
    if (allCategory !== undefined && +categoryId === +allCategory.value) {
      closeBulkAssignmentDrawer()
    } else {
      setBulkSelectedItems([])
      setBulkSelectedPeople([])
    }
  }

  const refreshView = () => {
    getItems(new AbortController())
  }

  const processItem = (row) => {
    if (
      !appUserRights.includes('WorkviewSelfCheckin') &&
      !appUserRights.includes('WorkviewOtherCheckin')
    ) {
      dispatch(setErrorToast('Missing user rights. Please contact your system admin.'))
      return
    }
    verifyWorkItemAssignment(row, false, true, (queriedRow) => {
      dispatch(openSpecificImage(queriedRow.ImageEnvelopeId, queriedRow.DLN))
      dispatch({ type: SET_SELECTED_ROW, selectedRow: queriedRow })
      row.EntryTypeName === 'Paper Filed' && getStaffDraftExists(queriedRow.ImageGroupId)
      if (queriedRow.UserId === -1 /* Unassigned */) {
        changeUser(userId, queriedRow.WorkViewItemId)
      }
      setProcessFlag(true) // this is used to ensure image viewer is instantiated before redirect.
    })
  }

  const isItemMineOrUnassigned = (rowUserId, rowLocked) => {
    if (!rowLocked)
      return (
        (rowUserId === -1 &&
          (appUserRights.includes('WorkviewSelfCheckin') ||
            appUserRights.includes('WorkviewOtherCheckin'))) ||
        rowUserId === userId
      )
    return rowUserId === userId
  }

  const showUnlockButton = (row) => {
    return row.Locked && appUserRights.includes('UnlockWorkViewManagerItems')
  }

  const verifyWorkItemAssignment = (row, reassign, lockItem, callback) => {
    setShowValidatingActionSpinner(true)
    api.GET_WORKVIEW_ITEM(
      row.WorkViewItemId,
      lockItem,
      (queriedRow) => {
        if (queriedRow.Locked && queriedRow.UserId !== userId) {
          dispatch(
            setErrorToast(
              `Work item DLN ${queriedRow.DLN} is being worked by ${queriedRow.UserFullName}`
            )
          )
        }
        if (queriedRow === null) {
          dispatch(
            setErrorToast(
              `Work item DLN ${row.DLN} was recently completed and is no longer in the queue.`
            )
          )
          refreshView()
        } else if (
          !reassign &&
          queriedRow.UserId !== -1 /* Unassigned */ &&
          queriedRow.UserId !== userId /* current user */
        ) {
          dispatch(
            setErrorToast(
              `Work item DLN ${queriedRow.DLN} is assigned to ${queriedRow.UserFullName}. Please select another.`
            )
          )
          refreshView()
        } else if (reassign && row.UserId !== queriedRow.UserId) {
          dispatch(
            setErrorToast(
              `Work item DLN ${queriedRow.DLN} was recently assigned to ${queriedRow.UserFullName}.`
            )
          )
          refreshView()
        } else {
          callback(queriedRow)
        }
        setShowValidatingActionSpinner(false)
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast(`Failed to verify work item assignment. Please try again.`))
        setShowValidatingActionSpinner(false)
      }
    )
  }

  const updateWorkViewItemRowHasNotes = () => {
    api.GET_WORKVIEW_ITEM(
      selectedRow.WorkViewItemId,
      selectedRow.Locked,
      (updatedRow) => {
        setResultRows((rows) =>
          rows.map((row) => (row.WorkViewItemId === selectedRow.WorkViewItemId ? updatedRow : row))
        )
        dispatch({ type: SET_SELECTED_ROW, selectedRow: updatedRow })
      },
      (err) => {
        console.error(err)
      }
    )
  }

  const navToCorrespondence = (row, type = 1) => {
    verifyWorkItemAssignment(row, false, true, (queriedRow) => {
      if (queriedRow.UserId === -1 /* Unassigned */) {
        changeUser(userId, queriedRow.WorkViewItemId)
      }
      dispatch(openSpecificImage(row.ImageEnvelopeId, row.DLN))
      dispatch({ type: SET_SELECTED_ROW, selectedRow: queriedRow })
      dispatch({ type: SET_CORRESPONDENCE_WORKVIEW_ITEM, row: queriedRow })
      history.push(
        `/office/correspondence/${type === 1 ? `reject` : `correct`}/${row.WorkViewItemId}`
      )
    })
  }

  const openWorkViewNotes = () => {
    setNotesOpen(true)
  }

  const getStaffDraftAndRedirect = (formDefinitionId, staffEntryRequired = false) => {
    api.GET_STAFF_DRAFT_EXISTS_BY_ID(
      selectedRow.ImageGroupId,
      (res) => {
        if (res) {
          let url = `/office/workview/draft/process/${res.FormDefinitionId}`
          if (selectedRow.Filing.Num) {
            url += `/${selectedRow.Filing.Num}`
          }
          history.push(url)
        } else {
          navigateToNewWizard(formDefinitionId, staffEntryRequired)
        }
      },
      (err) => {
        navigateToNewWizard(formDefinitionId, staffEntryRequired)
      }
    )
  }

  const navigateToNewWizard = (formDefinitionId, staffEntryRequired) => {
    // console.log(selectedRow);
    let url = `/office/workview/process/${formDefinitionId}`
    if (selectedRow.Filing.Num) {
      url += `/${selectedRow.Filing.Num}`
    }
    if (staffEntryRequired) {
      url += `?staffEntryRequired=true`
    }
    history.push(url)
  }

  const getStaffDraftExists = (ImageGroupId) => {
    api.GET_STAFF_DRAFT_EXISTS_BY_ID(
      ImageGroupId,
      (res) => {
        if (res) {
          dispatch({
            type: SET_RECORD_TO_AMEND,
            record: {
              'File #': res.FilingNum,
              'Doc #': res.DocNum,
              'Trademark #': res.TrademarkNum,
              SourceType: selectedRow.SourceTypeId,
            },
          })

          dispatch({
            type: 'SET_STAFF_DRAFT',
            staffDraft: res,
          })
        } else {
          dispatch({ type: 'SET_STAFF_DRAFT', staffDraft: null })
        }
      },
      (err) => {
        dispatch({ type: 'SET_STAFF_DRAFT', staffDraft: null })
        console.error(err.Message)
      }
    )
  }

  const closeCorrectionModalUnlockItem = () => {
    setCorrectionResolverOpen(false)
    api.UNLOCK_WORKVIEW_ITEM_BY_ID(
      selectedRow.WorkViewItemId,
      (unlockedRow) => {
        refreshView()
        setResultRows((rows) =>
          rows.map((row) => (row.WorkViewItemId === selectedRow.WorkViewItemId ? unlockedRow : row))
        )
        dispatch(setSuccessToast('Unlocked Work Item'))
      },
      (err) => {
        console.error(err)
        refreshView()
      }
    )
  }

  const closePaperModalUnlockItem = (skipUnlock = false) => {
    setPaperModalOpen(false)
    setOrderPaperModalOpen(false)
    setLegacyFilingModalOpen(false)
    setMiscPaperModalOpen(false)
    if (skipUnlock) return
    api.UNLOCK_WORKVIEW_ITEM_BY_ID(
      selectedRow.WorkViewItemId,
      (unlockedRow) => {
        setResultRows((rows) =>
          rows.map((row) => (row.WorkViewItemId === selectedRow.WorkViewItemId ? unlockedRow : row))
        )
        dispatch(setSuccessToast('Unlocked Work Item'))
      },
      (err) => {
        console.error(err)
      }
    )
  }
  const onSortModelChange = (sortModel) => {
    dispatch(setSuccessToast('Re-Sorting - Returning to the first page'))
    const sortCol = sortModel.length > 0 ? sortModel[0] : {}
    if (sortCol.field) {
      let sortBy = ''
      switch (sortCol.field) {
        case 'FileDate':
          sortBy = 'date'
          break
        case 'ResourceImagePageType':
          sortBy = 'type'
          break
        case 'UserFullName':
          sortBy = 'assigned'
          break
        case 'ProcessingStatusName':
          sortBy = 'status'
          break
        case 'DLN':
          sortBy = 'dln'
          break
        case 'ResourceName':
          sortBy = 'name'
          break
        case 'ResourceNum':
          sortBy = 'number'
          break
        case 'ResourceType':
          sortBy = 'reftype'
          break
        case 'EntryTypeName':
          sortBy = 'submit'
          break
        default:
          sortBy = ''
          break
      }
      setSortInfo({ orderBy: sortBy, orderByDesc: sortCol.sort === 'asc' ? false : true })
    } else {
      setSortInfo({})
    }
    setPage(0)
  }

  /* END functions */
  /* START useMemo */
  const assignToUserOptions = useMemo(() => {
    const activeCategory = workviewCategoryUsers.find(
      (category) => category.WorkViewID === activeCategoryId
    )
    if (activeCategory && activeCategory.Users && appUserRights.includes('WorkviewOtherCheckin')) {
      let users = activeCategory.Users.sort((a, b) =>
        a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0
      )

      let index = users.findIndex((user) => user.AppUserID == -1)
      if (index !== -1) {
        let unassignedUser = users.splice(index, 1)[0]
        users.unshift(unassignedUser)
      }

      return users.map((user) => {
        return {
          id: user.AppUserID,
          value: user.AppUserID,
          textLabel: user.Name,
          render: (text) => (
            <UserChip
              onClick={() => {
                changeUser(user.AppUserID, selectedRow.WorkViewItemId)
              }}
              displayName={text}
            />
          ),
        }
      })
    } else if (
      activeCategory &&
      activeCategory.Users &&
      appUserRights.includes('WorkviewSelfCheckin')
    ) {
      return [
        {
          id: userId,
          value: userId,
          textLabel: `${userFirstName} ${userLastName}`,
          render: (text) => (
            <UserChip
              displayName={text}
              onClick={() => {
                changeUser(userId, selectedRow.WorkViewItemId)
              }}
            />
          ),
        },
      ]
    } else {
      return [
        {
          id: userId,
          value: userId,
          textLabel: `${userFirstName} ${userLastName}`,
          render: (text) => <UserChip displayName={text} />,
        },
      ]
    }
  }, [appUserRights, activeCategoryId, workviewCategoryUsers, selectedRow])

  const activeCategory = useMemo(() => {
    return (
      workflowOptions.find((category) => category.WorkviewId === activeCategoryId) || { Count: 0 }
    )
  }, [workflowOptions, activeCategoryId])

  const categoryDropdownOptions = useMemo(() => {
    return workflowOptions
      .sort((a, b) => (a.Name > b.Name ? 1 : -1))
      .map((category) => {
        return {
          badgeText: category.Count.toString(),
          value: category.WorkviewId,
          label: category.Name,
          alignRight: true,
        }
      })
  }, [workflowOptions])

  const templateDefault = useMemo(() => {
    let template = [
      {
        field: 'PriorityName',
        flex: 0.75,
        headerName: 'Priority',
        disableColumnMenu: true,
        sortable: true,
        hidden: window.innerWidth > '800' ? true : false,
      },
      {
        field: 'FileDate',
        minWidth: 85,
        flex: 0.35,
        headerName: 'Date',
        disableColumnMenu: true,
        // renderCell: (params) =>
        //   params.row.FileDate && (
        //     <div>
        //       {format(new Date(params.row.FileDate), 'MM/dd/yyyy')}
        //       <br />
        //       {format(new Date(params.row.FileDate), 'hh:mm:ss a')}
        //     </div>
        //   ),
      },
      {
        field: 'ResourceImagePageType',
        flex: 0.5,
        headerName: 'Type',
        disableColumnMenu: true,
      },
      {
        field: 'UserFullName',
        flex: 0.75,
        minWidth: 100,
        headerName: 'Assigned To',
        disableColumnMenu: true,
        renderCell: (params) => (
          <UserChip
            onClick={(e) => {
              if (
                !params.row.Locked ||
                (params.row.Locked && userId === params.row.UserId) ||
                showUnlockButton(params.row)
              )
                verifyWorkItemAssignment(params.row, true, false, () => {
                  openAssignUserPopover(e)
                })
              else dispatch(setErrorToast('Missing right to reassign locked work item'))
            }}
            displayName={params.row.UserId == -1 ? `Unassigned` : params.row.UserFullName}
          />
        ),
      },
      {
        field: 'ProcessingStatusName',
        flex: 0.45,
        headerName: 'Status',
        disableColumnMenu: true,
      },
      {
        field: 'DLN',
        flex: 0.35,
        headerName: 'DLN',
        disableColumnMenu: true,
        renderCell: (params) => {
          if (activeWorkView?.UserRoleProcessIds?.some((id) => roles.map((role) => role.Id === id))) {
            return (
              <div
                className={params.row.DLN.indexOf(',') === -1 ? 'dlnTableLink' : ''}
                tabIndex={params.row.DLN.indexOf(',') === -1 ? 0 : -1}
                onClick={() => {
                  if (params.row.DLN.indexOf(',') !== -1) return
                  checkDLNValid(
                    params.row.DLN,
                    (id) => {
                      dispatch(openSpecificImage(id, params.row.DLN))
                    },
                    (dln) => {
                      dispatch(setErrorToast('DLN ' + dln + ' not found'))
                    }
                  )
                }}
              >
                {params.row.DLN}
              </div>
            )
          } else {
            return <div>{params.row.DLN}</div>
          }
        },
      },
      {
        field: 'ResourceName',
        flex: 0.6,
        headerName: 'Reference Name',
        minWidth: 75,
        disableColumnMenu: true,
      },
      {
        field: 'ResourceNum',
        flex: 0.8,
        headerName: 'Reference #',
        disableColumnMenu: true,
      },
      {
        field: 'ResourceType',
        flex: 0.6,
        headerName: 'Reference Type',
        disableColumnMenu: true,
      },
      {
        field: 'EntryTypeName',
        flex: 0.3,
        headerName: 'Submit Type',
        disableColumnMenu: true,
      },
    ]
    if (
      !bulkAssign &&
      activeWorkView &&
      activeWorkView.UserRoleProcessIds &&
      activeWorkView.UserRoleProcessIds.some((id) => roles.map((role) => role.Id === id))
    ) {
      template = [
        ...template,
        {
          field: 'Actions',
          headerName: 'Actions',
          flex: 0.5,
          resizeable: false,
          disableColumnMenu: true,
          sortable: false,
          renderCell: (params) => {
            const row = params.row
            return (
              <div className="action-icons-wrapper" style={{ display: `inline` }}>
                <IconButton
                  onClick={() => {
                    dispatch(openSpecificImage(row.ImageEnvelopeId, row.DLN))
                  }}
                  icon={<Document />}
                  label="Image"
                />
                {appUserRights.includes('ViewWorkViewNotes') && (
                  <IconButton
                    onClick={() => openWorkViewNotes(row)}
                    icon={row.HasNotes ? <FileBoxSolid /> : <FileBox />}
                    label={`View Notes`}
                  />
                )}
                {isItemMineOrUnassigned(row.UserId, row.Locked) &&
                  row.AllowCorrections &&
                  appUserRights.includes(`FileCorrection`) && (
                    <IconButton
                      onClick={() => navToCorrespondence(row, 2)}
                      icon={<Revert />}
                      label="Correct"
                    />
                  )}
                {isItemMineOrUnassigned(row.UserId, row.Locked) &&
                  row.ImageDataType !== 'Corrected Submission' &&
                  row.AllowRejections &&
                  appUserRights.includes(`FileRejection`) && (
                    <IconButton
                      onClick={() => navToCorrespondence(row, 1)}
                      icon={<Cross />}
                      label="Reject"
                    />
                  )}
                {isItemMineOrUnassigned(row.UserId, row.Locked) &&
                  row.ProcessingStatusName !== 'Needs Correction' && (
                    <IconButton
                      onClick={() => processItem(row)}
                      icon={<RightArrow />}
                      label="Process"
                    />
                  )}
                {row.Locked && (
                  <IconButton
                    label={showUnlockButton(row) ? 'Unlock Item' : 'Item In Work'}
                    icon={<LockKey />}
                    disabled={!showUnlockButton(row)}
                    onClick={() => {
                      if (showUnlockButton(row)) {
                        setShowValidatingActionSpinner(true)
                        api.UNLOCK_WORKVIEW_ITEM_BY_ID(
                          row.WorkViewItemId,
                          (unlockedItem) => {
                            // replace the row
                            setResultRows((oldRows) =>
                              oldRows.map((item) =>
                                item.WorkViewItemId === row.WorkViewItemId ? unlockedItem : item
                              )
                            )
                            dispatch(setSuccessToast('Unlocked Work Item'))
                            setShowValidatingActionSpinner(false)
                          },
                          (err) => {
                            console.error(err)
                            dispatch(setErrorToast('Failed to Unlock Work Item'))
                            setShowValidatingActionSpinner(false)
                          }
                        )
                      }
                    }}
                  />
                )}
              </div>
            )
          },
        },
      ]
    }
    return template
  }, [bulkAssign, isItemMineOrUnassigned, activeWorkView])

  const hasFiltering = useMemo(() => {
    if (!debouncedSearchText && !unassignedChecked && !myAssignedChecked) return false
    return true
  }, [unassignedChecked, myAssignedChecked, debouncedSearchText])

  const showBulkAssignButton = useMemo(() => {
    if (!appUserRights.includes('WorkviewSupervisorReview')) return false
    if (!activeCategoryId) return false
    const allCategory = (categoryDropdownOptions || []).find(
      (opt) => (opt.label || '').toUpperCase() === 'All'.toUpperCase()
    )
    if (allCategory && +activeCategoryId === +allCategory.value) return false
    return true
  }, [activeCategoryId, appUserRights, categoryDropdownOptions])

  const datagridRowCount = useMemo(() => {
    if (hasFiltering) return filteredRowCount
    if (activeCategory && activeCategory.Count) return activeCategory.Count
    return 0
  }, [hasFiltering, resultRows, filteredRowCount, activeCategory])
  /* END useMemo */

  return (
    <Body className="workview-manager" showDrawer={bulkAssign}>
      <div id="popover-wrapper" style={{ display: assignUserPopoverOpen ? 'block' : 'none' }}>
        {appUserRights.includes('WorkviewSelfCheckin') ||
        appUserRights.includes('WorkviewOtherCheckin') ? (
          <FilterablePopover
            onClickOutside={() => setAssignUserPopoverOpen(false)}
            className="popoverJSSelector"
            placeholder="Assign to..."
            customCss={`top: ${popoverLocation.top}px; left: ${popoverLocation.left}px; position: absolute; height: fit-content;`}
            options={assignToUserOptions}
          />
        ) : (
          <UserChip onClick={(e) => null} />
        )}
      </div>
      <div className="wvm-wrapper">
        <div className="actions-row">
          <div className="left-aligned">
            <div onClick={(e) => e.stopPropagation()}>
              <BoxSelect
                label="Current Work View"
                options={categoryDropdownOptions}
                value={activeCategoryId}
                onChange={changeView}
              />
            </div>
            <ButtBox
              className="buttbox"
              label="My Assigned"
              checked={myAssignedChecked}
              onChange={() =>
                dispatch({
                  type: SET_MY_ASSIGNED_CHECKED,
                  myAssignedChecked: !myAssignedChecked,
                })
              }
            />
            <ButtBox
              className="buttbox"
              label="Unassigned"
              checked={unassignedChecked}
              onChange={() =>
                dispatch({
                  type: SET_UNASSIGNED_CHECKED,
                  unassignedChecked: !unassignedChecked,
                })
              }
            />
          </div>
          <div className="wvm-search-wrapper">
            <SearchBox
              label="Search"
              placeholder={`Search...`}
              value={searchText}
              onChange={(e) => setSearchText(e)}
              onClear={() => setSearchText('')}
              showClearButton={true}
              showSearchButton={false}
            />
          </div>
        </div>
        <div className={`table-wrapper`}>
          <GraniteDataGrid
            loading={loading}
            columns={templateDefault}
            getRowId={(r) => r.WorkViewItemId}
            rows={resultRows || []}
            rowCount={datagridRowCount}
            page={page}
            onPageChange={(newPage) => setPage(newPage)}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[25, 50, 100]}
            onRowClick={(r) => dispatch({ type: SET_SELECTED_ROW, selectedRow: r.row })}
            onRowDoubleClick={(r) => {
              // if row is locked, prevent processing
              if (
                r.row.ProcessingStatusName !== 'Needs Correction' &&
                isItemMineOrUnassigned(r.row.UserId, r.row.Locked) &&
                activeWorkView &&
                activeWorkView.UserRoleProcessIds &&
                activeWorkView.UserRoleProcessIds.some((id) => roles.map((role) => role.Id === id))
              )
                processItem(r.row)
            }}
            paginationMode="server"
            checkboxSelection={bulkAssign}
            keepNonExistentRowsSelected
            selectionModel={bulkSelectedItems}
            onSelectionModelChange={(ids) => {
              // need to figure out if unselect all is clicked and clear the list.
              // OR teach users that clicking unselect all only applies to current page.
              setBulkSelectedItems(ids)
            }}
            sortingMode="server"
            onSortModelChange={onSortModelChange}
            getRowClassName={(params) => {
              return `${showWvmLockedColors && params.row.Locked ? 'row-locked' : ''} ${
                showWvmLockedColors && params.row.UserId === userId ? 'mine' : ''
              }`
            }}
          />
        </div>
      </div>
      <div className={'context-bar-wrapper ' + (sidebarCollapsed ? 'sidebar-collapsed ' : ' ')}>
        <ContextBar className="granite-context-bar">
          <ContextDataChip label="Total Records" value={`${activeCategory.Count}`} />
          <div className={`context-bar-item-wrapper`}>
            <div
              className={`context-bar-item ${
                !hasFiltering || filteredRowCount === activeCategory.Count ? 'hidden' : ''
              }`}
            >
              <ContextDataChip label="Filtered Records" value={filteredRowCount || 0} />
            </div>
            <div className={`context-bar-item ${!showBulkAssignButton ? `hidden` : ``}`}>
              <ContextButton
                variant={'secondary'}
                onClick={() => {
                  if (bulkAssign) closeBulkAssignmentDrawer()
                  else {
                    setBulkAssign(true)
                    refreshView()
                  }
                }}
              >
                {bulkAssign ? `Cancel` : `Bulk Assign`}
              </ContextButton>
            </div>
            <div className={`context-bar-item ${!showValidatingActionSpinner ? 'hidden' : ''}`}>
              <div style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px' }}>
                <Spinner size="small" themeColor="dark-neutral" />
              </div>
            </div>
          </div>
          {/* <ContextDataChip label="Processed/Hr" value={12.38} variant="success" /> PUT BACK IN LATER*/}
        </ContextBar>
      </div>
      <Drawer
        showCloseButton
        show={bulkAssign}
        title={`Bulk Assignments`}
        subtitle={`${bulkSelectedItems.length} item${
          bulkSelectedItems.length === 1 ? `` : `s`
        } will be assigned to ${bulkSelectedPeople.length} ${
          bulkSelectedPeople.length === 1 ? `person` : `people`
        }`}
        onSidebarDismiss={closeBulkAssignmentDrawer}
      >
        <BulkAssignment
          bulkSelectedPeople={bulkSelectedPeople}
          setBulkSelectedPeople={setBulkSelectedPeople}
          bulkSelectedItems={bulkSelectedItems}
          changeBulkUsers={changeBulkUsers}
          loading={loading}
        />
      </Drawer>
      <Portal isOpened={correctionResolverOpen}>
        <Modal
          title={'Processing Correction'}
          modalSize="large"
          cancelButton
          autoHeight
          closeModal={() => closeCorrectionModalUnlockItem()}
        >
          <CorrectionResolver
            selectedRow={selectedRow}
            closeCorrectionResolver={closeCorrectionModalUnlockItem}
            changeView={changeView}
          />
        </Modal>
      </Portal>
      <Portal isOpened={webModalOpen}>
        <Modal
          title={`Processing ${selectedRow.ResourceName || ''}`}
          modalSize="large"
          cancelButton
          autoHeight
          closeModal={() => {
            setWebModalOpen(false)
            setShowValidatingActionSpinner(true)
            api.UNLOCK_WORKVIEW_ITEM_BY_ID(
              selectedRow.WorkViewItemId,
              (unlockedRow) => {
                setResultRows((rows) =>
                  rows.map((row) =>
                    row.WorkViewItemId === selectedRow.WorkViewItemId ? unlockedRow : row
                  )
                )
                dispatch(setSuccessToast('Unlocked Work Item'))
                setShowValidatingActionSpinner(false)
              },
              (err) => {
                console.error(err)
                setShowValidatingActionSpinner(false)
              }
            )
          }}
        >
          <WebProcessModal
            id="process-modal"
            navToCorrespondence={navToCorrespondence}
            setWebModalOpen={setWebModalOpen}
            refreshView={refreshView}
            disabled={false}
            categoryId={activeCategoryId}
          />
        </Modal>
      </Portal>
      <Portal isOpened={paperModalOpen}>
        <Modal
          title="Process Paper Filing"
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => {
            closePaperModalUnlockItem()
            dispatch({
              type: SET_PAPER_FILING_ERROR_MESSAGE,
              paperFilingErrorMessage: '',
            })
          }}
        >
          <PaperProccessModal
            navToCorrespondence={navToCorrespondence}
            refreshView={refreshView}
            closePaperModalUnlockItem={closePaperModalUnlockItem}
          />
        </Modal>
      </Portal>
      <Portal isOpened={orderPaperModalOpen}>
        <Modal
          title="Process Order Paper Filing"
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => {
            closePaperModalUnlockItem()
            dispatch({
              type: SET_PAPER_FILING_ERROR_MESSAGE,
              paperFilingErrorMessage: '',
            })
          }}
        >
          <OrdersPaperProcessModal
            navToCorrespondence={navToCorrespondence}
            refreshView={refreshView}
            closePaperModalUnlockItem={closePaperModalUnlockItem}
          />
        </Modal>
      </Portal>
      <Portal isOpened={legacyFilingModalOpen}>
        <Modal
          title="Legacy Filing"
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => {
            closePaperModalUnlockItem()
            dispatch({
              type: SET_PAPER_FILING_ERROR_MESSAGE,
              paperFilingErrorMessage: '',
            })
          }}
        >
          <LegacyFilingsModal
            navToCorrespondence={navToCorrespondence}
            refreshView={refreshView}
            closePaperModalUnlockItem={closePaperModalUnlockItem}
          />
        </Modal>
      </Portal>
      <Portal isOpened={miscPaperModalOpen}>
        <Modal
          title="Process Miscellaneous Paper Filing"
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => {
            closePaperModalUnlockItem()
            dispatch({
              type: SET_PAPER_FILING_ERROR_MESSAGE,
              paperFilingErrorMessage: '',
            })
          }}
        >
          <MiscPaperProcessModal
            navToCorrespondence={navToCorrespondence}
            refreshView={refreshView}
            closePaperModalUnlockItem={closePaperModalUnlockItem}
          />
        </Modal>
      </Portal>
      <Portal isOpened={notesOpen}>
        <Modal
          title={`${selectedRow.ResourceName || selectedRow.ResourceImagePageType} - ${
            selectedRow.DLN
          } Notes`}
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => {
            setNotesOpen(false)
          }}
        >
          <WorkViewItemNotes updateRow={updateWorkViewItemRowHasNotes} />
        </Modal>
      </Portal>
    </Body>
  )
}

export default WorkviewManager

const newDTO = {
  AllowCorrections: true,
  Locked: true,
  StaffEntryRequiredFlag: false,
  IsInitialFiling: true,

  WorkViewItemId: 1,
  FormDefinitionId: 2,
  UserId: 3,

  Filing: {
    Name: 'Filing Name',
    Num: 'Filing Num',
    Id: 5,
    TypeId: 6,
    // SubTypeId: null,
  },

  Record: {
    Name: 'Record Name',
    Num: 'Record Num',
    Id: 5,
    TypeId: 6,
    SubTypeId: 7,
  },

  SourceId: 2,
  //SourceNum: 'Number',
  SourceTypeId: 4, // -> was ImageDataCategory, means 'Record Source Type Id'

  ImageEnvelopeId: 7, // want to remove later.
  ImageGroupId: 8,

  EntryTypeId: 2,
  // PriorityId: 8, // NOT USED ANYWHERE
  ProcessingStatusId: 9, // id, -> was RecordStatusID

  PriorityName: 'Standard',
  UserFullName: 'Unassigned',
  ProcessingStatusName: 'Pending Review',
  ResourceName: 'business name',
  ResourceNum: 'BE-1234',
  ResourceType: 'Test Type',
  EntryTypeName: 'Paper Filed',
  DLN: 'B1234-1234',

  FileDate: '04/08/2024 10:45 am', // pre-formatted
  ResourceImagePageType: 'Payment',
}
